import React, { useMemo, useState } from "react";
import useFetchOnlineReviewByPropertiesData from "../../../../hooks/useFetchOnlineReviewByPropertiesData";
import { convertCstDataIntoTableCompatibleTest, getMonthWithValues } from "../../../../../../utils/transformChartsAndTableData";
import { View } from "../../../../../../components/Common/react-native-components";
import { Dropdown, Typography } from "@hmsexp/component-library";
import { dropdownStyling } from "../../styles";
import { useSelector } from "react-redux";
import { parseFilters } from "../../../../../Filters/utils/fetchData";
import Pagination from "../../../../../../components/Common/Pagination";
import Loader from "./Loader";
import GraphTable from "../../../../../../components/Common/GraphTable";
import { FETCH_OVERVIEW_ONLINE_REVIEW_PROPERTIES_DRILL_DOWN_DATA_CAMPAIGN } from "../../../../actionTypes";

const OnlineReviewGraphTable = ({ lowSampleSize, selectedMetricOptions }) => {

    const { applied_filter_values } = useSelector(e => e?.filterReducer);
    const [selectedMetric, setSelectedMetric] = useState(selectedMetricOptions?.[0]?.value);
    const chart_options = {
        credits: {
            enabled: false
        },
        title: {
            text: ''
        },
        legend: {
            enabled: false
        },
        exporting: {
            enabled: false
        },
        chart: {
            width: 900,
            height: 400
        },
        xAxis: {
            categories: [],
            title: {
                text: ''
            }
        },
        yAxis: {
            title: {
                text: ''
            },
            min: 0
        },
        series: [
            {
                name: '',
                data: []
            }
        ],
        plotOptions: {
            series: {
                color: '#00008B'
            }
        }
    };
    const updatedFilters = useMemo(() => {
        const filters = parseFilters(applied_filter_values);
        return {
            ...filters,
            filters: {
                ...filters.filters,
                additional_filters: {
                    ...filters.filters?.additional_filters,
                    feedback_source: [selectedMetric]
                }
            }
        };
    }, [applied_filter_values, selectedMetric]);

    const { data, onPageChange, data_per_page, isLoading, page, totalPages } = useFetchOnlineReviewByPropertiesData({
        pageType: FETCH_OVERVIEW_ONLINE_REVIEW_PROPERTIES_DRILL_DOWN_DATA_CAMPAIGN,
        customFilters: updatedFilters,
        skip: !selectedMetric
    });

    const graphTableData = convertCstDataIntoTableCompatibleTest({ columns: data?.columns, metric_data: data?.metric_data, metric_count: data?.metric_count } || {});

    const finalData = {
        ...graphTableData,
        table_rows: graphTableData?.table_rows?.map(row => {
            const monthData = getMonthWithValues(row);
            const options = {
                ...chart_options,
                xAxis: {
                    ...chart_options.xAxis,
                    categories: monthData.months
                },
                series: chart_options.series.map((s, i) => ({
                    ...s,
                    data: i === 0 ? monthData.data : s.data
                }))
            };
            return {
                ...row,
                nested_rows: [
                    {
                        [graphTableData?.table_columns?.[0]?.field]: {
                            chart_options: options
                        }
                    }
                ]
            };
        })
    };


    return (
        <View>

            <Typography
                textProps={{ style: { marginBottom: 5 } }}
                variant='button'
                color='primaryContentMedium'
                fontWeightType='regular'>
                Question
            </Typography>

            <View style={{ maxWidth: 200 }}>
                <Dropdown
                    items={selectedMetricOptions}
                    onChange={(e) => {
                        setSelectedMetric(e)
                        onPageChange(0)
                    }}
                    value={selectedMetric}
                    label={''}
                    style={{
                        container: {
                            ...dropdownStyling.container, width: 250, minWidth: 250
                        },
                        optionContainer: dropdownStyling.optionContainer,
                        dropDownText: dropdownStyling.dropDownText,
                        icon: dropdownStyling.icon
                    }}
                />
            </View>
            {isLoading ? <Loader /> :
                <GraphTable lowSampleSize={lowSampleSize} graph_table_data={{ table_data: finalData }} />
            }
            <Pagination
                currentPage={page} totalRecords={totalPages} pageSize={data_per_page} onPageChange={onPageChange}

            />
        </View >)
};

export default OnlineReviewGraphTable;  